import {
    observer
  } from 'mobx-react-lite';
  import type { ApplicationSdk } from '../stores';
import UnauthorizedPage from '../pages/error/Unauthorized';

  
  const AuthView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    return <>
      {sdk.locationAction === 'error' ? <UnauthorizedPage /> : null}
      {sdk.locationAction === 'login' ? <>
        Du wirst eingeloggt
      </> : null}
    </>
  });
  
  export default AuthView;